import script from "./StudentBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentBanner.vue?vue&type=script&setup=true&lang=js"

import "./StudentBanner.vue?vue&type=style&index=0&id=ad95c4fa&scoped=true&lang=css"
import "./StudentBanner.vue?vue&type=style&index=1&id=ad95c4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad95c4fa"]])

export default __exports__